module.exports = __webpack_public_path__ + "img/wastebox_orange.min.1d7e2ab6.png";